import { useEffect } from 'react';

const Pets = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.petfinder.com/pet-scroller.bundle.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script when unmounting
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2 className="text-center mx-5 mt-5 mb-5">
        Thank You for Your Interest in Adoption
      </h2>
      <h3 className="text-center mx-5 mt-5 mb-5">
        Our adoptable dogs are listed on the Petfinder list below. If you see a
        dog you are interested in adopting or meeting, please fill out and
        submit our adoption application on our website by clicking{' '}
        <a
          href="https://puppypawsrescue.org/adopt"
          target="_blank"
          rel="noopener noreferrer"
        >
          here
        </a>
        . No meet and greets are done without filling out a no-obligation
        adoption application.
      </h3>
      <pet-scroller
        s3Url="https://dbw3zep4prcju.cloudfront.net/"
        apiBase="https://psl.petfinder.com/graphql"
        organization='["fb77924f-58dc-4fe3-8a35-10fa4a6bb852"]'
        status="adoptable"
        petfinderUrl="https://www.petfinder.com/"
        hideBreed="true"
        limit="12"
        petListTitle="Available Dogs"
      />
    </div>
  );
};

export default Pets;
